import type { SubscriptionsSummary } from './subscriptions-types';

/** Trial window is still open, including a paid plan granted as a trial. */
export const isTrialing = (summary: SubscriptionsSummary): boolean =>
  summary.subscription.status === 'trialing';

/**
 * The church has no active paid subscription to adjust, so checkout is how they
 * register or restore one.
 */
export const needsSubscriptionRegistration = (summary: SubscriptionsSummary): boolean =>
  isTrialing(summary) ||
  summary.subscription.plan === 'trial' ||
  summary.subscription.plan === 'community' ||
  Boolean(summary.community.requiresPaidUpgrade) ||
  Boolean(summary.starter?.requiresUpgrade) ||
  summary.subscription.status === 'expired' ||
  summary.subscription.status === 'past_due' ||
  summary.subscription.status === 'grace' ||
  summary.subscription.status === 'suspended' ||
  summary.subscription.status === 'cancelled';

export const canOpenPlanCheckout = (summary: SubscriptionsSummary): boolean =>
  needsSubscriptionRegistration(summary) || Boolean(summary.management?.canAdjustPlan);
